import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { imgSrc } from "@/lib/settings";
import { Input } from "@/components/ui/input";
import { Upload } from "lucide-react";

export default function UploadField({ label, value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await api.post("/admin/upload", fd);
      onChange(res.data.url);
      toast.success("Image téléversée");
    } catch {
      toast.error("Échec du téléversement de l'image.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      <label className="text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]">{label}</label>
      <div className="mt-2 flex items-center gap-3">
        {value ? <img src={imgSrc(value)} alt="" className="h-14 w-14 shrink-0 border border-black/10 object-cover" /> : null}
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)}
               placeholder="https://… ou téléversez une image"
               className="h-11 rounded-none border-black/10 bg-transparent text-sm font-light" data-testid={`${testid}-url`} />
        <label className="flex shrink-0 cursor-pointer items-center gap-2 rounded-full bg-[var(--brand-dark)] px-4 py-2.5 text-[11px] uppercase tracking-[0.15em] text-[var(--brand-bg)] transition-transform duration-200 hover:scale-95"
               data-testid={`${testid}-upload`}>
          <Upload size={13} /> {uploading ? "Envoi…" : "Téléverser"}
          <input type="file" accept="image/*" className="hidden" onChange={upload} />
        </label>
      </div>
    </div>
  );
}
